import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const Trivia: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'musicquizlandingpage_title_musictriviaforalloccasions_standalone-web',
							{ns: 'musicquiz'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'musicquizlandingpage_text_musictriviaforalloccasions_standalone-web',
							{ns: 'musicquiz'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					src="999fb2da30656259e1fcdda9a803da77.png"
					aspectRatio="2048/597"
					alt={t('generic_action_playnow_standalone-web', {ns: 'common'})}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{
						eventaction: 'discover-channel-game',
						eventlabel: 'section4',
					}}
					href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fchannels%2Fgames%3Fbypassreferer%3D1&amv=8.0.12&imv=10.12.0"
				>
					{t('generic_action_tryitnowfeature_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
